/**
 * Helper to translate and format upload errors into user-friendly Portuguese messages
 */
export const formatUploadErrorMessage = (error) => {
  if (!error) return "Erro desconhecido durante o upload.";

  const raw = typeof error === "string" ? error : error.message || error.code || String(error);
  const code = (error && typeof error === "object" && error.code) ? String(error.code).toLowerCase() : "";
  const lowerRaw = raw.toLowerCase();

  // 1. Storage error codes
  if (code.includes("storage/unauthorized") || lowerRaw.includes("storage/unauthorized") || lowerRaw.includes("does not have permission to access")) {
    return "Sem permissão para salvar no Storage. Verifique se você está autenticado ou se sua conta tem permissão ativa.";
  }
  if (code.includes("storage/unauthenticated") || lowerRaw.includes("storage/unauthenticated")) {
    return "Sessão expirada ou não autenticado. Faça login novamente no aplicativo.";
  }
  if (code.includes("storage/retry-limit-exceeded") || lowerRaw.includes("retry-limit-exceeded")) {
    return "Tempo limite de conexão excedido. A conexão com a internet pode estar lenta ou instável.";
  }
  if (code.includes("storage/quota-exceeded") || lowerRaw.includes("quota-exceeded")) {
    return "Cota de armazenamento do Firebase excedida. Entre em contato com o suporte.";
  }
  if (code.includes("storage/canceled") || lowerRaw.includes("storage/canceled")) {
    return "Envio cancelado pelo usuário.";
  }
  if (code.includes("storage/invalid-checksum") || lowerRaw.includes("invalid-checksum")) {
    return "Falha na integridade do arquivo enviado.";
  }

  // 2. Firestore error codes
  if (code.includes("permission-denied") || lowerRaw.includes("permission-denied") || lowerRaw.includes("missing or insufficient permissions")) {
    return "Permissão negada no banco de dados. Verifique se o seu usuário está com cadastro ativo.";
  }
  if (code.includes("unavailable") || lowerRaw.includes("unavailable")) {
    return "Serviço temporariamente indisponível. Verifique sua conexão com a internet.";
  }

  // 3. Application errors
  if (lowerRaw.includes("nome duplicado") || lowerRaw.includes("já existe um arquivo")) {
    return raw;
  }

  // 4. Network / Mobile browser errors
  if (
    lowerRaw.includes("network-request-failed") ||
    lowerRaw.includes("failed to fetch") ||
    lowerRaw.includes("networkerror") ||
    lowerRaw.includes("the operation was aborted")
  ) {
    return "Falha de conexão com a rede. Verifique seu sinal Wi-Fi ou dados móveis.";
  }

  // 5. Clean up technical prefixes like "FirebaseError: Firebase Storage: "
  const cleaned = raw
    .replace(/^FirebaseError:\s*/i, "")
    .replace(/^Firebase Storage:\s*/i, "")
    .trim();

  return cleaned || "Falha no envio do arquivo.";
};
